<template>
  <div class="pa-3">
    <v-row class="mb-2">
      <v-col col="6">
        <v-btn color="secondary" v-if="buttonShow('create')" @click="openCreatePaymentConsolidateModal(null)">
          <v-icon left>mdi-newspaper-plus</v-icon>Create
        </v-btn>
        <!-- <v-btn color="secondary" v-if="buttonShow('create')" @click="openInvoiceModal">
          <v-icon left>mdi-file-upload-outline</v-icon> Upload Invoice
        </v-btn> -->
        <v-btn color="secondary" v-if="buttonShow('create')" @click="openViewInvoiceModal">
          <v-icon>mdi-file-check</v-icon> View Invoices
        </v-btn>
        <v-btn color="secondary" @click="exportReportAllBatch()"><v-icon small>mdi-file-excel</v-icon> Export Excel</v-btn>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <div class="d-flex justify-content-between">
          <div class="mx-2">
            <!-- <v-checkbox
              class="imported-only-checkbox"
              style="min-width:150px;max-width:150px;"
              v-model="mainFilter.POC"
              label="POC Only"
              color="secondary"
              :value="false"
              hide-details
              @change="getPaymentConsolidateReport()"
            ></v-checkbox> -->

          </div>
          <!-- Global Live Month Filter -->
          <div class="mx-2 mt-2" style="max-width:200px">
            <v-menu
              ref="globalLiveDatePicker"
              v-model="globalFilter.liveDatePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              dense
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="Live Month"
                  v-model="globalFilter.searchliveDateMonth"
                  readonly
                  clearable
                  outlined
                  dense
                  hide-details="auto"
                  v-bind="attrs"
                  v-on="on"
                  @change="searchLiveDataFilter()"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="globalFilter.searchliveDateMonth"
                type="month"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="secondary"
                  @click="cancelGlobalMonth('liveDate')"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="secondary"
                  @click="searchGlobalMonthOk('liveDate')"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
          <v-text-field
            v-model="searchText"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            @keyup="searchGlobal()"
          ></v-text-field>
        </div>
      </v-col>
    </v-row>
    <div class="payment-consolidate-section" :id="batch.batchNo" v-for="(batch, bindex) in batches" :key="bindex">
      <v-expansion-panels class="expansion-panels mb-5" v-model="batch.panel" multiple accordion>
        <v-expansion-panel class="expansion-panel-main" expand>
          <v-expansion-panel-header class="expansion-panel-header">
            <h3 class="pa-0 ma-0">{{batch.name}}</h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="expansion-panel-content">
            <v-row class="no-gutters">
              <!-- <v-col cols="12" sm="12" md="12" lg="12">
                <v-btn color="success" class="mb-2" v-if="!batch.disableSaveEdit" @click="saveEditingData(batch.displayData, batch)">Save Changes</v-btn>
                <v-btn color="warning" class="mb-2" v-if="!batch.disableSaveEdit" @click="cancelEdit(batch.displayData, batch)">Cancel</v-btn>
              </v-col> -->
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-row class="action-section mb-3">
                  <v-col class="action-group-section" cols="12" sm="3" md="3" lg="3">
                    <div class="d-flex flex-row" style="gap:3px">
                      <v-btn color="warning" class="mb-2" small @click="exportReport(batch)"><v-icon small>mdi-file-excel</v-icon> Export Excel</v-btn>
                      <div v-if="allowedActions(batch.batchNo)">
                        <v-btn
                          class="mb-2"
                          color="warning"
                          small
                          v-if="batch.selectedPayments && batch.selectedPayments.length > 0 && batch.status !== paymentStatus.PAID "
                          @click="openPaymentUpdateModal(batch.selectedPayments)"
                        >Update Status ({{batch.selectedPayments.length}})</v-btn>
                        <v-btn
                        style="color:#fff"
                        class="btn-payment-action"
                        color="red mb-2"
                        small
                        v-if="isDeleteAction(batch.selectedPayments) && batch.status !== paymentStatus.PAID"
                        @click="deleteMultipleReport()">
                          <v-icon small>mdi-delete</v-icon> Delete
                        </v-btn>
                        <v-btn
                        color="warning"
                        class="mb-2"
                        small
                        v-if="batch.selectedPayments && batch.selectedPayments.length > 0"
                        @click="saveArchive(batch)">
                          <v-icon small>mdi-archive</v-icon> Archive
                        </v-btn>
                        <v-btn color="success" class="mb-2" small v-if="!batch.disableSaveEdit" @click="saveChanges(batch.displayData, batch)">Save Changes</v-btn>
                        <v-btn color="warning" class="mb-2" small v-if="!batch.disableSaveEdit" @click="cancelEdit(batch.displayData, batch)">Cancel</v-btn>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="9" md="9" lg="9">
                    <div class="d-flex justify-content-right float-right">
                      <div class="mx-2" style="min-width:150px">
                        <v-text-field
                          v-model="batch.filter.search"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                          @keyup="changeSearch(batch, batch.filter, batch.filter.search)"
                        ></v-text-field>
                      </div>
                      <div class="mx-2">
                        <v-checkbox
                          class="imported-only-checkbox"
                          style="min-width:150px;max-width:150px;"
                          v-model="batch.filter.imported"
                          label="Imported Only"
                          color="secondary"
                          :value="false"
                          hide-details
                          @change="searchFilter(batch)"
                        ></v-checkbox>
                      </div>
                      <div class="mx-2 mt-2" style="max-width:200px">
                        <v-autocomplete
                          label="All CC"
                          v-model="batch.filter.cc"
                          :items="CCUsers"
                          item-text="name"
                          item-value="id"
                          @change="searchFilter(batch)"
                          dense
                          outlined
                          hide-details
                        >
                        </v-autocomplete>
                      </div>
                      <div class="mx-2 mt-2" style="max-width:200px">
                        <v-autocomplete
                          label=""
                          v-model="batch.filter.country"
                          :items="filterCountries"
                          item-text="name"
                          item-value="name"
                          @change="searchFilter(batch)"
                          dense
                          outlined
                          hide-details
                        >
                        </v-autocomplete>
                      </div>
                      <!-- <div class="mx-2 mt-2" v-if="allowFilters('liveDate', batch.batchNo)">
                        <v-menu
                          ref="liveDatePicker"
                          v-model="batch.filter.liveDatePicker"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          dense
                          max-width="290px"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              label="Live Date"
                              v-model="batch.filter.searchliveDateMonth"
                              readonly
                              clearable
                              outlined
                              dense
                              hide-details="auto"
                              v-bind="attrs"
                              v-on="on"
                              @change="searchFilter(batch)"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="batch.filter.searchliveDateMonth"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="secondary"
                                @click="cancelMonth(batch, 'liveDate')"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="secondary"
                                @click="searchMonthOk(batch, 'liveDate')"
                            >
                                OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </div>
                      <div class="mx-2 mt-2" v-if="allowFilters('dueDate', batch.batchNo)">
                        <v-menu
                          ref="dueDatePicker"
                          v-model="batch.filter.dueDatePicker"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          dense
                          max-width="290px"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              label="Due Date"
                              v-model="batch.filter.searchDueDateMonth"
                              readonly
                              clearable
                              outlined
                              dense
                              hide-details="auto"
                              v-bind="attrs"
                              v-on="on"
                              @change="searchFilter(batch)"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="batch.filter.searchDueDateMonth"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="secondary"
                                @click="cancelMonth(batch, 'dueDate')"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="secondary"
                                @click="searchMonthOk(batch, 'dueDate')"
                            >
                                OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </div> -->
                      <div class="mx-2 mt-2" v-if="allowFilters('paymentDate', batch.batchNo)">
                        <v-menu
                          ref="paymentDatePicker"
                          v-model="batch.filter.paymentDatePicker"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          dense
                          max-width="290px"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              label="Payment Date"
                              v-model="batch.filter.searchPaymentDateMonth"
                              readonly
                              clearable
                              outlined
                              dense
                              hide-details="auto"
                              v-bind="attrs"
                              v-on="on"
                              @change="searchFilter(batch)"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="batch.filter.searchPaymentDateMonth"
                            type="month"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="secondary"
                                @click="cancelMonth(batch, 'paymentDate')"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="secondary"
                                @click="searchMonthOk(batch, 'paymentDate')"
                            >
                                OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </div>
                      <div class="mx-2">
                        <v-btn class="mt-3" small @click="resetFilter(batch)">Reset</v-btn>
                      </div>
                    </div>
                  </v-col>
                  <!-- <v-col cols="12" sm="2" md="2" lg="2">
                    <v-text-field
                      v-model="batch.filter.search"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      @keyup="changeSearch(batch.filter, batch.filter.search)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="1" md="1" lg="1" style="margin-top:8px;">
                    <v-checkbox
                      class="imported-only-checkbox mt-0"
                      style="max-width:150px;float:right;"
                      v-model="batch.filter.imported"
                      label="Imported Only"
                      color="secondary"
                      :value="false"
                      hide-details
                      @change="searchFilter(batch)"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="1" md="1" lg="1" style="margin-top:8px;">
                    <v-select
                      label=""
                      v-model="batch.filter.country"
                      :items="filterCountries"
                      item-text="name"
                      item-value="name"
                      @change="searchFilter(batch)"
                      dense
                      outlined
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" style="margin-top:8px;">
                    <v-menu
                      ref="liveDatePicker"
                      v-model="batch.filter.liveDatePicker"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      dense
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          label="Live Date"
                          v-model="batch.filter.searchliveDateMonth"
                          readonly
                          clearable
                          outlined
                          dense
                          hide-details="auto"
                          v-bind="attrs"
                          v-on="on"
                          @change="searchFilter(batch)"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="batch.filter.searchliveDateMonth"
                        type="month"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="secondary"
                            @click="cancelMonth(batch, 'liveDate')"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="secondary"
                            @click="searchMonthOk(batch, 'liveDate')"
                        >
                            OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" style="margin-top:8px;">
                    <v-menu
                      ref="dueDatePicker"
                      v-model="batch.filter.dueDatePicker"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      dense
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          label="Due Date"
                          v-model="batch.filter.searchDueDateMonth"
                          readonly
                          clearable
                          outlined
                          dense
                          hide-details="auto"
                          v-bind="attrs"
                          v-on="on"
                          @change="searchFilter(batch)"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="batch.filter.searchDueDateMonth"
                        type="month"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="secondary"
                            @click="cancelMonth(batch, 'dueDate')"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="secondary"
                            @click="searchMonthOk(batch, 'dueDate')"
                        >
                            OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col> -->
                  <!-- <v-col cols="12" sm="3" md="3" lg="3">
                    <v-select
                      class="input-field pt-3"
                      v-model="batch.filter.paymentStatus"
                      :items="paymentStatusOptions"
                      item-value="status"
                      item-text="display"
                      label="Payment Status"
                      dense
                      outlined
                    ></v-select>
                  </v-col> -->
                </v-row>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-data-table
                  :headers="batch.headers"
                  :items="batch.displayData"
                  :items-per-page="10"
                  :search="batch.filter.workingSearch"
                  :no-data-text="'Empty list'"
                  class="table-small payment-consolidate-table elevation-1"
                  :key="dataTableKey"
                  show-select
                  :single-select="false"
                  v-model="batch.selectedPayments"
                  @toggle-select-all="selectAllPayments"
                  @current-items="getFiltered"
                >
                  <template v-slot:[`item.data-table-select`]="{item}">
                    <v-checkbox
                      class="custom-checkbox"
                      v-model="batch.selectedPayments"
                      label=""
                      :value="item"
                      color="grey darken-2"
                    ></v-checkbox>
                  </template>
                  <template v-slot:[`item.instagram`]="{ item }">
                    <a
                      :href="'https://facebook.com/' + item.instagram"
                      target="_blank"
                      v-if="item.isFacebook || item.fbOwner"
                    ><v-icon style="color:#1877F2 !important;" small>mdi-facebook</v-icon> @{{item.instagram}}</a>
                    <a
                      :href="'https://www.tiktok.com/@' + item.instagram"
                      target="_blank"
                      v-else-if="item.isTikTok || item.tiktokOwner"
                    ><img src="/static/img/tiktok-32.png" width="20px" /> @{{item.instagram}}</a>
                    <a
                      :href="'https://youtube.com/@' + item.instagram"
                      target="_blank"
                      v-else-if="item.isYoutube || item.youtubeOwner"
                    ><v-icon style="color:#FF0000 !important;">mdi-youtube</v-icon> @{{item.instagram}}</a>
                    <a
                      :href="'https://www.linkedin.com/in/' + item.instagram"
                      target="_blank"
                      rel="noopener noreferrer"
                      v-else-if="isLinkedInPayment(item) || item.linkedinOwner"
                    ><v-icon style="color:#0A66C2 !important;" small>mdi-linkedin</v-icon> @{{item.instagram}}</a>
                    <a
                      :href="'https://x.com/' + item.instagram"
                      target="_blank"
                      rel="noopener noreferrer"
                      v-else-if="item.twitterOwner || isTwitterPayment(item)"
                    ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true" /> @{{item.instagram}}</a>
                    <a
                      :href="'https://www.xiaohongshu.com/user/profile/' + item.xhsID"
                      target="_blank"
                      v-else-if="item.isXHS || item.xhsOwner"
                    ><img src="/static/img/xhs-black.png" width="20px" class="payment-xhs-logo" /> {{item.fullName || item.instagram}}</a>
                    <a
                      :href="'https://www.instagram.com/' + item.instagram"
                      target="_blank"
                      v-else
                    ><v-icon style="color:#E1306C !important;" small>mdi-instagram</v-icon> @{{item.instagram}}</a>
                    <v-menu
                      bottom
                      origin="center center"
                      transition="scale-transition"
                      v-if="item.platformHandlesObj && item.platformHandlesObj.length > 1"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          dark
                          text
                          v-bind="attrs"
                          v-on="on"
                          style="min-width:0;padding:0;margin-left:-9px;margin-top:-3px;"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon class="ml-2" color="warning" v-on="on" small>mdi-chevron-down-circle</v-icon>
                            </template>
                            <span>Multiple Accounts detected</span>
                          </v-tooltip>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(obj, i) in item.platformHandlesObj"
                          :key="i"
                        >
                          <v-list-item-title>
                            <!-- <v-avatar size="35" color="grey lighten-4">
                              <img
                                class="elevation-6"
                                v-bind:src="paserImageUrl(obj.picture)"
                                alt="avatar"
                              >
                            </v-avatar> -->
                            <a
                              v-if="obj.type === 'xhs'"
                            ><img src="/static/img/xhs-black.png" width="20px" class="payment-xhs-logo" /> @{{obj.handle}}</a>
                            <a
                              v-else-if="obj.type === 'facebook'"
                            ><v-icon style="color:#1877F2 !important;" small>mdi-facebook</v-icon> @{{obj.handle}}</a>
                            <a
                              v-else-if="obj.type === 'tiktok'"
                            ><img src="/static/img/tiktok-32.png" width="20px" /> @{{obj.handle}}</a>
                            <a
                              v-else-if="obj.type === 'youtube'"
                            ><v-icon style="color:#FF0000 !important;">mdi-youtube</v-icon> @{{obj.handle}}</a>
                            <a
                              v-else-if="obj.type === 'linkedin'"
                            ><v-icon style="color:#0A66C2 !important;" small>mdi-linkedin</v-icon> @{{obj.handle}}</a>
                            <a
                              v-else-if="obj.type === 'twitter' || obj.type === 'x'"
                            ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true" /> @{{obj.handle}}</a>
                            <a
                              v-else
                            ><v-icon style="color:#E1306C !important;" small>mdi-instagram</v-icon> @{{obj.handle}}</a>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-icon small color="secondary" data-toggle="tooltip" data-placement="bottom" title="Imported" v-if="item.imported">mdi-newspaper-plus</v-icon>
                  </template>
                  <template v-slot:[`item.liveDate`]="{ item }">
                    <div style="min-width:70px">{{item.liveDate}}</div>
                  </template>
                  <template v-slot:[`item.dueDate`]="{ item }">
                    <div v-if="item.overdue">
                      <v-chip
                        small
                        color="red"
                        text-color="white"
                      >
                      {{item.dueDate}}
                      </v-chip>
                    </div>
                    <div v-else-if="item.early">
                      <v-chip
                        small
                        color="yellow"
                        text-color="black"
                      >
                      {{item.dueDate}}
                      </v-chip>
                    </div>
                    <div style="min-width:70px" v-else>{{item.dueDate}}</div>
                  </template>
                  <template v-slot:[`item.swiftCode`]="{ item }">
                    <div class="item-edit" @click="openEditItem(item, 'swiftCode', batch)" v-if="item.swiftCodeEdit === false">
                      <td class="text-xs-left" style="min-width:75px">{{item.swiftCode}}</td>
                    </div>
                    <div v-else>
                      <v-text-field
                        class="input-field mt-3"
                        v-model="item.swiftCode"
                        dense
                        outlined
                        v-on:keyup.native="changeSwiftCode(item)"
                      ></v-text-field>
                    </div>
                  </template>
                  <template v-slot:[`item.bankAccount`]="{ item }">
                    <div class="item-edit" @click="openEditItem(item, 'bankAccount', batch)" v-if="item.bankAccountEdit === false">
                      <td class="text-xs-left" style="min-width:75px">{{item.bankAccount}}</td>
                    </div>
                    <div v-else>
                      <v-text-field
                        class="input-field mt-3"
                        v-model="item.bankAccount"
                        v-on="on"
                        dense
                        outlined
                      ></v-text-field>
                    </div>
                  </template>
                  <template v-slot:[`item.username`]="{ item }">
                    <div class="item-edit" @click="openEditItem(item, 'username', batch)" v-if="item.usernameEdit === false">
                      <td class="text-xs-left" style="min-width:75px">{{item.username}}</td>
                    </div>
                    <div v-else>
                      <v-text-field
                        class="input-field mt-3"
                        v-model="item.username"
                        v-on="on"
                        dense
                        outlined
                      ></v-text-field>
                    </div>
                  </template>
                  <template v-slot:[`item.country`]="{ item }">
                    <div class="item-edit" @click="openEditItem(item, 'country', batch)" v-if="item.countryEdit === false">
                      <td class="text-xs-left" style="min-width:75px">{{item.country}}</td>
                    </div>
                    <div class="mt-3" v-else>
                      <v-select
                        label=""
                        v-model="item.country"
                        :items="countries"
                        item-text="name"
                        item-value="name"
                        @change="changeCountry"
                        dense
                        outlined
                      >
                      </v-select>
                    </div>
                  </template>
                  <template v-slot:[`item.bankName`]="{ item }">
                    <div class="item-edit" @click="openEditItem(item, 'bankName', batch)" v-if="item.bankNameEdit === false">
                      <td class="text-xs-left" style="min-width:75px">{{ typeof item.bankName === 'object' ? item.bankName.bank : item.bankName }}</td>
                    </div>
                    <div class="mt-3" v-else>
                      <v-combobox
                        v-model="item.bankName"
                        :items="bankNames"
                        label="Bank Name (select your bank)"
                        item-text="bank"
                        item-value="bank"
                        :search-input.sync="newBankName"
                        attach
                        dense
                        outlined
                        @change="changeBankName(item)"
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <span class="subheading pr-2" v-if="newBankName">{{ newBankName }}</span>
                          </v-list-item>
                        </template>
                      </v-combobox>
                    </div>
                  </template>
                  <template v-slot:[`item.email`]="{ item }">
                    <div class="item-edit" @click="openEditItem(item, 'email', batch)" v-if="item.emailEdit === false">
                      <td class="text-xs-left" style="min-width:75px">{{item.email}}</td>
                    </div>
                    <div v-else>
                      <v-text-field
                        class="input-field mt-3"
                        v-model="item.email"
                        v-on="on"
                        dense
                        outlined
                      ></v-text-field>
                    </div>
                  </template>
                  <template v-slot:[`item.amount`]="{ item }">
                    <div v-if="item.amountLocked">
                        <td class="text-xs-left" style="min-width:75px">-</td>
                    </div>
                    <div v-else>
                      <td class="text-xs-left" style="min-width:75px">
                        <!-- <v-chip class="ma-1" color="primary" small text-color="white">
                          <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                          {{item.amount | thousandSeprator}}
                        </v-chip> -->
                        <!-- <v-btn
                          color="secondary"
                          small
                          v-bind="attrs"
                          v-on="on"
                          text
                        >
                          <span v-if="!item.GSTPercent">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <div v-on="on">
                                  {{utils.currencySym(item.currency)}} {{item.amount | thousandSeprator}}
                                </div>
                              </template>
                              <span>{{item.currency}} {{item.amount | thousandSeprator}}</span>
                            </v-tooltip>
                          </span>
                          <span data-toggle="tooltip" data-placement="top" :title="displayGSTText(item)" v-if="item.GSTPercent">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <div v-on="on">
                                  {{utils.currencySym(item.currency)}} {{item.amount | thousandSeprator}}
                                </div>
                              </template>
                              <span>{{item.currency}} {{item.amount | thousandSeprator}}</span>
                            </v-tooltip>
                          </span>
                          <v-icon small color="warning" data-toggle="tooltip" data-placement="top" title="Special Payment Terms" v-if="item.specialPayment">mdi-alert-circle-outline</v-icon>
                          <v-icon small color="warning" data-toggle="tooltip" data-placement="top" title="GST enabled" v-if="item.GSTPercent">mdi-alert-circle</v-icon>
                        </v-btn> -->
                        <!-- <v-tooltip bottom max-width="300px" v-if="item.paidAmount || (item.pairedAmount && item.paymentStatus === paymentStatus.PAID)">
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-btn
                                color="secondary"
                                small
                                v-bind="attrs"
                                v-on="on"
                                text
                              >
                                <span v-if="!item.GSTPercent">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <div v-on="on">
                                        {{utils.currencySym(item.currency)}} {{item.amount | thousandSeprator}}
                                      </div>
                                    </template>
                                    <span>{{item.currency}} {{item.amount | thousandSeprator}}</span>
                                  </v-tooltip>
                                </span>
                                <span data-toggle="tooltip" data-placement="top" :title="displayGSTText(item)" v-if="item.GSTPercent">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <div v-on="on">
                                        {{utils.currencySym(item.currency)}} {{item.amount | thousandSeprator}}
                                      </div>
                                    </template>
                                    <span>{{item.currency}} {{item.amount | thousandSeprator}}</span>
                                  </v-tooltip>
                                </span>
                                <v-icon small color="warning" data-toggle="tooltip" data-placement="top" title="Special Payment Terms" v-if="item.specialPayment">mdi-alert-circle-outline</v-icon>
                                <v-icon small color="warning" data-toggle="tooltip" data-placement="top" title="GST enabled" v-if="item.GSTPercent">mdi-alert-circle</v-icon>
                              </v-btn>
                            </div>
                          </template>
                          <div v-if="item.paidAmount">
                            <span>Imported Amount: {{utils.currencySym(item.currency)}} {{item.paidAmount}}</span>
                            <p class="mb-0">Remain Amount: {{utils.currencySym(item.currency)}} {{item.amount}}</p>
                          </div>
                          <div v-if="item.pairedAmount">
                            <span>Paired Amount: {{utils.currencySym(item.currency)}} {{item.pairedAmount}}</span>
                            <p class="mb-0" v-if="item.remainAmount">Remain Amount: {{utils.currencySym(item.currency)}} {{item.remainAmount}}</p>
                          </div>
                        </v-tooltip> -->
                        <v-btn
                          color="secondary"
                          small
                          v-bind="attrs"
                          v-on="on"
                          text
                        >
                          <span v-if="!item.GSTPercent">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <div v-on="on">
                                  {{utils.currencySym(item.currency)}} {{item.amount | thousandSeprator}}
                                </div>
                              </template>
                              <span>{{item.currency}} {{item.amount | thousandSeprator}}</span><br>
                              <span v-if="item.sgdAmt">Estimated SGD: {{item.sgdAmt}}</span>
                            </v-tooltip>
                          </span>
                          <span data-toggle="tooltip" data-placement="top" :title="displayGSTText(item)" v-if="item.GSTPercent">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <div v-on="on">
                                  {{utils.currencySym(item.currency)}} {{item.amount | thousandSeprator}}
                                </div>
                              </template>
                              <span>{{item.currency}} {{item.amount | thousandSeprator}}</span><br>
                              <span v-if="item.sgdAmt">Estimated SGD: {{item.sgdAmt}}</span>
                            </v-tooltip>
                          </span>
                          <v-icon small color="secondary" data-toggle="tooltip" data-placement="bottom" title="Special Payment Terms" v-if="item.specialPayment">mdi-alert-circle-outline</v-icon>
                          <v-icon small color="secondary" data-toggle="tooltip" data-placement="top" title="GST enabled" v-if="item.GSTPercent">mdi-alert-circle</v-icon>
                        </v-btn>
                        <v-btn
                        v-if="batch.status === paymentStatus.PAID && item.currency !== 'SGD'"
                        @click.stop="openActualAmountDialog(item)"
                        color="secondary"
                        x-small>
                          <v-icon x-small >edit</v-icon>
                          <span v-if="!item.actualAmount">Actual Amount</span>
                          <span v-if="item.actualAmount">S$ {{item.actualAmount | thousandSeprator}}</span>
                        </v-btn>
                      </td>
                    </div>
                  </template>
                  <template v-slot:[`item.PVNumber`]="{ item }">
                    <!-- <div class="item-edit">
                      <td class="text-xs-left" style="min-width:75px">{{item.paymentDate}}</td>
                    </div> -->
                    <div class="item-edit" @click="openEditItem(item, 'PVNumber', batch)" v-if="item.PVNumberEdit === false">
                      <td class="text-xs-left" style="min-width:75px">{{item.PVNumber}}</td>
                    </div>
                    <div v-else>
                      <v-text-field
                        class="input-field mt-3"
                        v-model="item.PVNumber"
                        v-on="on"
                        dense
                        outlined
                      ></v-text-field>
                    </div>
                  </template>
                  <template v-slot:[`item.paymentStatus`]="{ item }">
                    <div @click="openEditItem(item, 'paymentStatus', batch)" v-if="item.paymentStatusEdit === false">
                      <td class="text-xs-left" style="min-width:50px">{{getPaymentStatus(item.paymentStatus)}}</td>
                    </div>
                    <div v-else>
                      <td class="text-xs-left" style="min-width:50px">
                        <v-select
                          class="input-field pt-3"
                          v-model="item.paymentStatus"
                          :items="filterPaymentStatusOptions(item)"
                          item-value="status"
                          item-text="display"
                          label="Payment Status"
                          dense
                          outlined
                          @change="changePaymentStatus(item)"
                        ></v-select>
                      </td>
                    </div>
                  </template>
                  <template v-slot:[`item.paymentDate`]="{ item }">
                    <!-- <div class="item-edit">
                      <td class="text-xs-left" style="min-width:75px">{{item.paymentDate}}</td>
                    </div> -->
                    <div class="item-edit" @click="openEditItem(item, 'paymentDate', batch)" v-if="item.paymentDateEdit === false">
                      <td class="text-xs-left" style="min-width:75px">{{item.paymentDate}}</td>
                    </div>
                    <div v-else>
                      <v-text-field
                        class="input-field mt-3"
                        v-model="item.paymentDate"
                        v-on="on"
                        dense
                        outlined
                      ></v-text-field>
                    </div>
                  </template>
                  <template v-slot:[`item.paymentSubmissionDate`]="{ item }">
                    <div class="item-edit">
                      <td class="text-xs-left" style="min-width:75px">{{item.paymentSubmissionDate}}</td>
                    </div>
                  </template>
                  <template v-slot:[`item.bankReference`]="{ item }">
                    <!-- <div class="item-edit">
                      <td class="text-xs-left" style="min-width:75px">{{item.bankReference}}</td>
                    </div> -->
                    <div class="item-edit" @click="openEditItem(item, 'bankReference', batch)" v-if="item.bankReferenceEdit === false">
                      <td class="text-xs-left" style="min-width:75px">{{item.bankReference}}</td>
                    </div>
                    <div v-else>
                      <v-text-field
                        class="input-field mt-3"
                        v-model="item.bankReference"
                        v-on="on"
                        dense
                        outlined
                      ></v-text-field>
                    </div>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <div class="pt-2 pb-2 px-2">
                      <div class="pt-1">
                        <v-btn class="btn-payment-action" :to="'/campaign-report-internal?id='+item.campaignID" target="_blank" color="info" small>
                          <i class="fas fa-eye"></i>&nbsp;Campaign Report
                        </v-btn>
                      </div>
                      <div class="pt-1">
                        <v-btn class="btn-payment-action" color="warning" @click="openPaymentInvoiceModal(item)" small>
                          <i class="fas fa-upload"></i>&nbsp;Manage Invoices
                        </v-btn>
                      </div>
                      <div class="pt-1" v-if="item.paymentStatus !== paymentStatus.PAID">
                        <v-badge
                          @click.stop="openReportNotesDialog(item)"
                          :value="getNoteUnreadCount(item)"
                          :content="getNoteUnreadCount(item)"
                          color="green"
                          overlap
                        >
                          <v-btn
                          class="btn-payment-action"
                          @click.stop="openReportNotesDialog(item)"
                          color="warning"
                          small>
                            <v-icon color="white" small>edit</v-icon> Edit Note
                          </v-btn>
                        </v-badge>
                      </div>
                      <div class="pt-1">
                        <v-btn
                          style="color:#fff"
                          class="btn-payment-action"
                          color="red"
                          small
                          v-if="item.batchNo === 'imported'"
                          @click="deleteReport(item.id, item)"
                        >
                          <v-icon color="white" small>mdi-delete</v-icon> Delete
                        </v-btn>
                      </div>
                    </div>
                  </template>

                  <!-- Start Footer Area -->
                  <template slot="body.append">
                    <tr>
                      <th class="subtitle-2" colspan="9">Total Amount:</th>
                      <th colspan="12">
                        <v-chip
                          small
                          color="primary"
                          text-color="white"
                        >
                        <v-icon small left class="mr-0">mdi-currency-usd</v-icon> {{fixTwoDec(batch.totalAmount)}}
                        </v-chip>
                      </th>
                    </tr>
                  </template>
                  <!-- End Footer Area -->
                </v-data-table>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <!-- Uploaded Invoice Lists Section -->
    <!-- <uploaded-invoice-section v-if="batches.length > 0"/> -->

    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
    <update-payment-info-modal
      :payments="selectedPayments"
      :selectedPaymentStatus="selectedPaymentStatus"
      @updated="getPaymentConsolidateReport"
      v-model="paymentInfoDialog"
    />
    <partial-amount-modal
      :report="selectedReport"
      v-model="partialAmountDialog"
      @updated="getPaymentConsolidateReport"
    />
    <actual-amount-modal
      :report="selectedReport"
      v-model="actualAmountDialog"
      @updated="getPaymentConsolidateReport"
    />
    <!-- Report Notes Dialog -->
    <report-notes-modal
    v-model="reportNotesDialog"
    :value="reportNotesDialog"
    :data="reportNotesData"
    @savedNotes="getPaymentConsolidateReport"/>

    <!-- Create Payout Dialog -->
    <create-payment-consolidate-modal
    v-model="createPaymentConsolidateDialog"
    :value="createPaymentConsolidateDialog"
    :reports="consolidateReports"
    :editData="editInvoice"
    :reportUpdate="reportUpdate"
    @created="refreshPayCons"/>

    <!-- Invoice Dialog -->
    <upload-invoice-modal
    v-model="invoiceDialog"
    :value="invoiceDialog"
    @created="getPaymentConsolidateReport"/>

    <!-- Uploaded Invoice Dialog -->
    <uploaded-invoice-list-modal
    v-model="invoiceViewDialog"
    :value="invoiceViewDialog"
    @updated="getPaymentConsolidateReport"
    @openEdit="openCreatePaymentConsolidateModal"
    />
    <payment-invoice-modal
    v-model="paymentInvoiceDialog"
    :value="paymentInvoiceDialog"
    :payment="selectedInvoicePayment"
    @updated="refreshPayCons"
    />

    <!-- View Archive Dialog -->
    <!-- <archive-list-modal
      v-model="archiveViewDialog"
      :headers="headers"
      :items="displayArchives"
      @updated="getPaymentConsolidateReport"
    /> -->
  </div>
</template>
<script>
/* eslint-disable */
import campaignAPIs from '../Campaign/campaignAPIs';
import paymentAPIs from './paymentAPIs';
import userAPIs from '../User/userAPIs';
import influencerAPIs from '../Influencer/influencerAPIs';
import pairingAPIs from '../Pairing/pairingAPIs';
import config from '@/config';
import campaignConfig from '../Campaign/config'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
import UpdatePaymentInfoModal from './UpdatePaymentInfoModal';
import PartialAmountModal from './PartialAmountModal';
import ActualAmountModal from './ActualAmountModal';
import reportNotesModal from './reportNotesModal';
import CreatePaymentConsolidateModal from './CreatePaymentConsolidateModal';
import UploadInvoiceModal from './UploadInvoiceModal';
import UploadedInvoiceListModal from './UploadedInvoiceListModal';
import PaymentInvoiceModal from './PaymentInvoiceModal';
// import ArchiveListModal from './ArchiveListModal';
import orderBy from 'lodash/orderBy';
import { mapState, mapGetters } from 'vuex';
import utils from '../../../utils';
const FileSaver = require('file-saver')
import countries from '../../../../static/sources/countries';
import swiftCodes from '../../../../static/sources/swift_codes';
import bankAccounts from '../../../../static/sources/bank_accounts';
export default {
  name: 'PaymentConsolidation',
  components: {
    UpdatePaymentInfoModal,
    PartialAmountModal,
    ActualAmountModal,
    reportNotesModal,
    CreatePaymentConsolidateModal,
    UploadInvoiceModal,
    UploadedInvoiceListModal,
    PaymentInvoiceModal,
    // ArchiveListModal,
    Loading
  },
  data () {
    return {
      headers: [
        // {value: 'submissionDate', text: 'Submission Date', sortable: true},
        {value: 'liveDate', text: 'Live Date', sortable: true},
        {value: 'dueDate', text: 'Due Date', sortable: true},
        {value: 'swiftCode', text: 'Swift Code', sortable: true},
        {value: 'bankAccount', text: 'Bank A/C No.', sortable: true},
        {value: 'username', text: 'Payee Name', sortable: true},
        {value: 'country', text: 'Country', sortable: true},
        {value: 'bankName', text: 'Bank Name', sortable: true},
        {value: 'email', text: 'Email', sortable: true},
        {value: 'amount', text: 'Amount', sortable: true},
        {value: 'instagram', text: 'Handle', sortable: true},
        {value: 'clientName', text: 'Client Name', sortable: true},
        {value: 'campaignName', text: 'Campaign Name', sortable: true},
        {value: 'IONumber', text: 'Campaign IO Number', sortable: true},
        {value: 'PVNumber', text: 'PV Number', sortable: true},
        {value: 'paymentDate', text: 'Payment Date (DD/MM/YYYY)', sortable: true},
        {value: 'paymentSubmissionDate', text: 'Submission Date (DD/MM/YYYY)', sortable: true},
        {value: 'paymentStatus', text: 'Payment Status', sortable: true},
        {value: 'bankReference', text: 'Bank Reference', sortable: true},
        {value: 'POCDisplay', text: 'CC', sortable: true},
        {value: 'batch', text: 'Batch No', sortable: true},
        {value: 'agreedDeliverables', text: 'Agreed Deliverables', sortable: true},
        {value: 'deliverables', text: 'Produced Deliverables', sortable: true},
        {value: 'action', text: 'Actions', sortable: true}
      ],
      batchOne: [],
      batchTwo: [],
      defaultSections: {
        imported: [],
        batchOne: [],
        batchTwo: [],
        approvalFinance: [],
        // approvalLead: [],
        partiallyPaid: [],
        completed: []
      },
      batchSections: {},
      batches: [],
      archiveReportSections: {},
      // displayArchives: [],
      paidPanel: [0],
      paymentStatus: campaignConfig.paymentStatus,
      sectionIDs: campaignConfig.paymentConsSectionIDs,
      Users: [],
      CCUsers: [],
      selectedPayments: [],
      selectedReport: {},
      campaigns: [],
      originalPosts: [],
      countries: [],
      selectedPaymentStatus: '',
      editInvoice: {},
      swiftCodes: [],
      bankNames: [],
      newBankName: '',
      allBanks: [],
      disableBankSelect: false,
      reportUpdate: false,
      isLoading: false,
      isPaidLoading: false,
      paymentInfoDialog: false,
      partialAmountDialog: false,
      actualAmountDialog: false,
      reportNotesDialog: false,
      createPaymentConsolidateDialog: false,
      invoiceDialog: false,
      invoiceViewDialog: false,
      paymentInvoiceDialog: false,
      selectedInvoicePayment: {},
      // archiveViewDialog: false,
      searchText: '',
      filterCountries: [],
      mainFilter: {
        POC: false
      },
      globalFilter: {
        liveDatePicker: false,
        searchliveDateMonth: ''
      },
      utils: utils.func
    }
  },
  async mounted() {
    this.setCountries()
    this.changeCountry('Singapore')
    // These requests are independent prerequisites for formatting payment
    // rows, so load them together before retrieving the four collections.
    await Promise.all([
      this.$store.dispatch('payment/getCurrencyRates'),
      this.getAllUsers(),
      this.getUploadedInvoiceLists()
    ])
    await this.getPaymentConsolidateReport()
    // Retrieve swift code manullay
    this.swiftCodes = swiftCodes
  },
  computed: {
    ...mapState({
      paymentStatuses: state => state.payment.status,
      sectionsByRoles: state => state.payment.sectionsByRoles,
      exportTypes: state => state.payment.exportTypes,
      bankSwiftCodes: state => state.payment.bankSwiftCodes,
      consolidateReports: state => state.campaign.consolidateReports,
      archiveReports: state => state.campaign.archiveReports,
      updatedReport: state => state.campaign.updatedReport,
      preProcessingPayments: state => state.payment.preProcessingPayments,
      importedPayments: state => state.payment.importedPayments,
      completedPayments: state => state.payment.completedPayments,
      savedCompletedPayments: state => state.payment.savedCompletedPayments,
      currencyRates: state => state.payment.currencyRates,
      invoiceLists: state => state.campaign.invoiceLists
    }),
    ...mapGetters('payment', [
      'paymentStatusOptions',
      'allowedStatuses',
      'allowedActions',
      'allowTableFieldEdit',
      'allowFilters',
      'formatPosts',
      'formatPreProcessingPayments',
      'formatImportedPayments',
      'formatFinancePayments',
      'formatCompletedPayments',
      'setBatchTableSections',
      'searchParams'
    ]),
    currentUserID: function () {
      return this.$store.state.user.id;
    },
    currentUserRole: function () {
      return this.$store.state.user.role;
    }
  },
  methods: {
    getPaymentPlatform(item) {
      const details = (item && item.influencer_details) || {}
      const platform = details.platform || item.platform || details.activePlatform || item.activePlatform || ''
      const normalizedPlatform = String(platform).trim().toLowerCase()
      return normalizedPlatform === 'x' ? 'twitter' : normalizedPlatform
    },
    isLinkedInPayment(item) {
      return this.getPaymentPlatform(item) === 'linkedin'
    },
    isTwitterPayment(item) {
      return this.getPaymentPlatform(item) === 'twitter'
    },
    async enrichTwitterPayments(payments) {
      const influencerIDs = [...new Set(payments.map(payment => {
        const details = payment.influencer_details || {}
        return payment.influencerID || details.influencerID
      }).filter(Boolean))]

      if (!influencerIDs.length) return

      try {
        const influencers = await influencerAPIs.getInfluencerByIds({ searchIds: influencerIDs })
        const influencersByID = (influencers || []).reduce((profiles, influencer) => {
          profiles[influencer.id] = influencer
          return profiles
        }, {})

        payments.forEach(payment => {
          const details = payment.influencer_details || {}
          const influencerID = payment.influencerID || details.influencerID
          const influencer = influencersByID[influencerID]
          const recordPlatform = String(details.platform || payment.platform || '').toLowerCase()
          if (recordPlatform && recordPlatform !== 'twitter' && recordPlatform !== 'x') return
          if (!influencer || String(influencer.activePlatform).toLowerCase() !== 'twitter') return

          this.$set(payment, 'isTwitter', true)
          this.$set(payment, 'platform', 'twitter')
          if (influencer.twitterHandle) {
            this.$set(payment, 'instagram', influencer.twitterHandle)
          }
        })
      } catch (error) {
        console.log('Error resolving payment platforms:', error)
      }
    },
    async getPaymentConsolidateReport(payload = {}) {
      this.isLoading = true;
      this.oldBatches = Object.assign([], this.batches)
      let posts = []
      // await this.$store.dispatch('campaign/getPaymentConsolidateReport', payload)
      // let posts = this.consolidateReports;
      // All four collections are shown on this page. Fetch them concurrently
      // while preserving the same complete, active-record result set.
      await Promise.all([
        this.$store.dispatch('payment/getPreProcessingPayments', {}),
        this.$store.dispatch('payment/getImportedPayments', {}),
        this.$store.dispatch('payment/getFinancePayments', {}),
        this.$store.dispatch('payment/getCompletedPayments', {})
      ])

      let preProcessingPayments = this.formatPreProcessingPayments(this.CCUsers, this.invoiceLists)
      preProcessingPayments.map(payment => {
        posts.push(payment)
      })
      let importedPayments = this.formatImportedPayments(this.CCUsers, this.invoiceLists)
      importedPayments.map(payment => {
        posts.push(payment)
      })
      let financePayments = this.formatFinancePayments(this.CCUsers, this.invoiceLists)
      financePayments.map(payment => {
        posts.push(payment)
      })
      let formattedCompletedPayments = this.formatCompletedPayments(this.CCUsers, this.invoiceLists)
      formattedCompletedPayments.map(payment => {
        posts.push(payment)
      })
      await this.enrichTwitterPayments(posts)
      this.clearBatches()
      let formattedRets = this.formatPosts(posts, this.batchSections, this.CCUsers, this.mainFilter)
      posts = formattedRets.posts
      this.batchSections = formattedRets.sections
      this.setBatchTableSections(this.batches, this.headers, this.batchSections)
      this.restoreChanges()
      this.batches = utils.func.refreshJSON(this.batches)
      this.batches = this.batches.filter(b => b.batchNo !== '')
      this.isLoading = false;
      this.setFilterCountries()
    },
    getPaymentStatus(statusVal) {
      let statusText = '-'
      Object.entries(this.paymentStatuses).forEach(item => {
        if (statusVal === item[1].value) {
          statusText = item[1].text
        }
      });
      return statusText
    },
    openEditItem(item, itemName, batch) {
      if (!this.allowTableFieldEdit(itemName, batch.batchNo)) return false
      item[itemName + 'Edit'] = true
      item.editReport = true
      batch.disableSaveEdit = false
    },
    saveChanges(posts, batch) {
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          this.isLoading = true;
          let data = posts.filter(item => {
            if (this.checkReportUpdate(item)) {
              return true
            }
            return false
          })
          let unregisteredInfluencers = []
          data = data.map(item => {
            // Handle bankName - if object, extract bank property; if string, use as is
            let bankNameValue = ''
            if (item.bankName && typeof item.bankName === 'object' && item.bankName.bank) {
              bankNameValue = item.bankName.bank
            } else if (item.bankName && typeof item.bankName === 'string') {
              bankNameValue = item.bankName
            }
            let updateObj = Object.assign({}, {
              id: item.id,
              influencerID: item.influencerID,
              handle: item.instagram,
              platform: item.platform,
              campaignID: item.campaignID,
              type: item.type,
              swift_code: item.swiftCode,
              bank_account: item.bankAccount,
              country: item.country,
              bankName: bankNameValue,
              email: item.email,
              fullName: item.username,
              payment_date: item.paymentDate,
              payment_status: item.paymentStatus,
              bank_reference: item.bankReference,
              PVNumber: item.PVNumber,
              pairingID: item.pairingID || null
            })
            if (item.imported && item.imported !== undefined) {
              updateObj.imported = item.imported
            }
            if (this.currentUserRole === config.userRoles.AD_STRATEGIST) {
              // POC only update for ads
              let newPOC = Object.assign({}, {
                id: this.currentUserID,
                timestamp: moment().toISOString()
              })
              let POC = item.POC || []
              let oldPOC = POC.find(p => p.id === this.currentUserID)
              if (!oldPOC) {
                POC.unshift(newPOC)
                updateObj.POC = POC
              }
            }
            if (!item.influencerID && item.editReport) {
              unregisteredInfluencers.push(updateObj)
            }
            return updateObj
          })
          // Submit request to save edited report data
          campaignAPIs
          .savePaymentConsolidatedData(data)
          .then(async (response) => {
            // Update submitting status
            this.isLoading = false;
            // this.getPaymentConsolidateReport()
            this.cancelEdit(posts, batch)
            if (unregisteredInfluencers.length) {
              for (let unregInf of unregisteredInfluencers) {
                await this.$store.dispatch('pairing/savePairingBillingInfo', [unregInf])
              }
            }
            // Inline Payment Consolidation edits belong to the collection row
            // for its current stage.  Do this for registered and unregistered
            // influencers alike; Report documents are no longer a payment store.
            for (let d of data) {
              if (d.payment_status === this.paymentStatus.PROCESSING && !d.imported) {
                await paymentAPIs.updatePreProcessingPayment(d)
              } else if (d.payment_status === this.paymentStatus.PROCESSING && d.imported) {
                await paymentAPIs.updateImportedPayment(d)
              } else if (d.payment_status === this.paymentStatus.APPROVAL_FINANCE || d.payment_status === this.paymentStatus.PARTIAL) {
                await paymentAPIs.updateProcessingPayment(d)
              }
            }
            // Show success message
            this.$swal({
              text: 'Payment Updated',
              type: 'success'
            });
            // this.reloadManually()
            await this.getPaymentConsolidateReport()
            document.getElementById(batch.batchNo).scrollIntoView();
          })
          .catch(error => {
            // Update submitting status
            this.isLoading = false;
            // Request failed.
            console.log('error', error);
            this.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    saveArchive(batch) {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to archive?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          if (batch.status === this.paymentStatus.PAID) {
            // if completed stage, archive in both report and complete payments
            this.archiveCompletedPayments(batch)
            return
          }
          // if other stages, juz contineu
          let selected = batch.selectedPayments
          let data = selected.map(item => {
            return Object.assign({}, {
              id: item.id,
              archive: true
            })
          })
          // Submit request to save archived report data
          await this.$store.dispatch('campaign/updateReportsByIds', data)
          this.isLoading = false;
          if (!this.updatedReport) {
            this.$swal({
              text: 'Error Archiving Reports.',
              type: 'error'
            });
            return
          }
          this.cancelEdit(batch.displayData, batch)
          // Show success message
          this.$swal({
            text: 'Successfully Archived.',
            type: 'success'
          });
          this.getPaymentConsolidateReport()
        }
      })
    },
    async archiveCompletedPayments(batch) {
      let selected = batch.selectedPayments
      let reportArchiveData = []
      let completedArchiveData = []
      selected.map(item => {
        reportArchiveData.push(Object.assign({}, {
          id: item.reportID,
          archive: true
        }))
        completedArchiveData.push(Object.assign({}, {
          id: item.id,
          archive: true
        }))
      })
      // Submit request to save archived report data
      await this.$store.dispatch('campaign/updateReportsByIds', reportArchiveData)
      await this.$store.dispatch('payment/saveCompletedPayments', {
        data: completedArchiveData
      })
      this.isLoading = false;
      if (!this.updatedReport || !this.savedCompletedPayments) {
        this.$swal({
          text: 'Error Archiving Reports.',
          type: 'error'
        });
        return
      }
      // Show success message
      this.$swal({
        text: 'Successfully Archived.',
        type: 'success'
      });
      this.getPaymentConsolidateReport()
    },
    cancelEdit(posts, batch) {
      posts = posts.map(inf => {
        inf = this.setDefaultEditFields(inf)
        return inf
      })
      batch.disableSaveEdit = true
    },
    setDefaultEditFields(obj) {
      obj.swiftCodeEdit = false;
      obj.bankAccountEdit = false;
      obj.usernameEdit = false;
      obj.paymentDateEdit = false;
      obj.bankReferenceEdit = false;
      obj.paymentStatusEdit = false;
      obj.emailEdit = false;
      obj.bankNameEdit = false;
      obj.countryEdit = false;
      obj.PVNumberEdit = false;
      obj.editReport = false;
      return obj;
    },
    selectAllPayments($event) {
      if ($event.value && $event.items.length === 0) {
        return;
      }
      let batchIndex = null
      if ($event.items.length > 0) {
        batchIndex = this.batches.findIndex(i => i.batchNo === $event.items[0].batchNo)
      }
      if (!$event.value) {
        this.batches[batchIndex].selectedPayments = [];
        // return;
      }
      // let filteredItems = $event.items.filter(item => {
      //   if (this.checkDisabled(item)) {
      //     return false
      //   }
      //   return true
      // })
      let filteredItems = $event.items.filter(item => {
        if (!$event.value) {
          return false
        }
        return true
      })
      this.batches[batchIndex].selectedPayments = Object.assign([], filteredItems)
    },
    getFiltered(filtered, batch = null) {
      let batchIndex = null
      if (filtered.length > 0) {
        batchIndex = this.batches.findIndex(i => i.batchNo === filtered[0].batchNo)
        this.batches[batchIndex].totalAmount = this.calculateTotalAmt(filtered)
      } else {
        // if no results found, set empty for total amt
        if (batch) {
          batchIndex = this.batches.findIndex(i => i.batchNo === batch.batchNo)
          this.batches[batchIndex].totalAmount = 0
        }
      }
    },
    calculateTotalAmt(items) {
      return items.map(item => item.amount ? Number(item.amount) : 0).reduce((a, b) => a + b)
    },
    openPaymentUpdateModal(selectedPayments) {
      this.selectedPayments = selectedPayments
      let batchNo = this.selectedPayments[0].batchNo
      let matchBatch = this.batches.find(batch => batch.batchNo === batchNo)
      this.selectedPaymentStatus = matchBatch.status
      this.paymentInfoDialog = true
    },
    openPartialAmountDialog(item) {
      if (item.payment_status === this.paymentStatus.APPROVAL_LEAD ||
      item.payment_status === this.paymentStatus.APPROVAL_LEAD ||
      item.payment_status === this.paymentStatus.PARTIAL) {
        this.selectedReport = item
        this.partialAmountDialog = true
      }
      return false
    },
    openActualAmountDialog(item) {
      if (item.payment_status === this.paymentStatus.PAID) {
        this.selectedReport = item
        this.actualAmountDialog = true
      }
      return false
    },
    async openPaymentInvoiceModal(item) {
      this.selectedInvoicePayment = Object.assign({}, item, { signedInvoices: [] })
      this.paymentInvoiceDialog = true
      if (!item.pairingID) return

      try {
        const signedInvoices = await pairingAPIs.getSignedInvoices(item.pairingID)
        if (this.selectedInvoicePayment.pairingID === item.pairingID) {
          this.$set(this.selectedInvoicePayment, 'signedInvoices', signedInvoices)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async exportReport(batch) {
      this.isLoading = true
      // Campaign metadata is only needed to build export reference numbers.
      // Keep it off the page's initial loading path.
      await this.fetchCampaignList()
      let exportData = []
      if (batch.selectedPayments.length) {
        batch.selectedPayments = orderBy(batch.selectedPayments, ['IONumber'], ['asc'])
        exportData = batch.selectedPayments.map(data => {
          return this.beautifyExportData(data)
        })
      } else {
        batch.displayData = orderBy(batch.displayData, ['IONumber'], ['asc'])
        exportData = batch.displayData.map(data => {
          return this.beautifyExportData(data)
        })
      }
      campaignAPIs
        .exportBankReport(exportData, batch.exportType)
        .then(response => {
          this.isLoading = false;
          const blob = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          if (batch.exportType === this.exportTypes.CO) {
            FileSaver.saveAs(blob, `${batch.name}_${moment().format('X')}.xlsx`)
          } else {
            FileSaver.saveAs(blob, `bank_import_${moment().format('X')}.xlsx`)
          }
        })
        .catch(error => {
          // Update submitting status
          this.isLoading = false;
          // Request failed.
          console.log('error', error);
          this.$swal({
            text: error,
            type: 'error'
          });
        });
    },
    async exportReportAllBatch() {
      this.isLoading = true
      await this.fetchCampaignList()
      let exportData = []
      for (let batch of this.batches) {
        if (Array.isArray(batch.displayData)) {
          for (let data of batch.displayData) {
            let newData = this.beautifyExportData(data)
            exportData.push(newData)
          }
        }
      }
      campaignAPIs
        .exportBankReport(exportData, this.exportTypes.CO)
        .then(response => {
          this.isLoading = false;
          const blob = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          FileSaver.saveAs(blob, `payment_consolidation_${moment().format('X')}.xlsx`)
        })
        .catch(error => {
          // Update submitting status
          this.isLoading = false;
          // Request failed.
          console.log('error', error);
          this.$swal({
            text: error,
            type: 'error'
          });
        });
    },
    beautifyExportData(data, type) {
      const campaign = this.campaigns.find(c => c.id === data.campaignID)
      let refNo = 'KOBE'
      if (campaign) {
        if (campaign.campaignCode !== undefined) {
          refNo += 'x' + campaign.campaignCode.split('-')[0]
        }
      }
      let handle = ''
      if (data.isXHS || data.xhsOwner) {
        handle = data.fullName || data.instagram
      } else {
        handle = data.instagram
      }
      return {
        liveDate: data.liveDate,
        dueDate: data.dueDate,
        handle,
        swiftCode: data.swiftCode,
        bankAccount: data.bankAccount,
        bankAccountName: data.username,
        country: data.country,
        bankName: data.bankName,
        email: data.email,
        amount: data.amount,
        campaignName: data.campaignName,
        clientName: data.clientName,
        IONumber: data.IONumber,
        CO: data.CO,
        remark: '',
        paymentDate: data.paymentDate,
        paymentSubmissionDate: data.paymentSubmissionDate,
        paymentStatus: this.getPaymentStatus(data.paymentStatus),
        beneficiaryRef: refNo,
        POCDisplay: data.POCDisplay,
        agreedDeliverables: data.agreedDeliverables,
        deliverables: data.deliverables
      }
    },
    searchFilter(batch, filterOnly = false) {
      batch.displayData = Object.assign([], batch.data)
      if (batch.filter.searchliveDateMonth) {
        batch.displayData = batch.displayData.filter(b => {
          let searchMonth = utils.func.parseDate(b.liveDate)
          return searchMonth === batch.filter.searchliveDateMonth
        })
      }
      if (batch.filter.searchDueDateMonth) {
        batch.displayData = batch.displayData.filter(b => {
          let searchMonth = utils.func.parseDate(b.dueDate)
          return searchMonth === batch.filter.searchDueDateMonth
        })
      }
      if (batch.filter.searchPaymentDateMonth) {
        batch.displayData = batch.displayData.filter(b => {
          let searchMonth = utils.func.parseMonth(b.paymentDate)
          return searchMonth === batch.filter.searchPaymentDateMonth
        })
      }
      if (batch.filter.imported) {
        batch.displayData = batch.displayData.filter(b => b.imported)
      }
      if (batch.filter.cc && batch.filter.cc !== 'All') {
        batch.displayData = batch.displayData.filter(b => b.assignedTo && b.assignedTo.includes(batch.filter.cc))
      }
      if (batch.filter.country && batch.filter.country !== 'All Country') {
        batch.displayData = batch.displayData.filter(b => b.country === batch.filter.country)
      }
      if (filterOnly) return batch // if filter only, no need refresh data
      this.batches = utils.func.refreshJSON(this.batches)
      this.getFiltered(batch.displayData, batch)
    },
    searchLiveDataFilter(batches) {
      // Apply global liveDate filter to all batches
      if (!this.globalFilter.searchliveDateMonth) {
        // If filter is cleared, restore all batches to original displayData
        this.batches.forEach(batch => {
          batch.displayData = Object.assign([], batch.data)
          this.searchFilter(batch, true)
          this.getFiltered(batch.displayData, batch)
        })
        return
      }
      // Filter all batches by the global liveDate month
      this.batches.forEach(batch => {
        batch.displayData = batch.data.filter(item => {
          let searchMonth = utils.func.parseMonth(item.liveDate)
          return searchMonth === this.globalFilter.searchliveDateMonth
        })
        this.getFiltered(batch.displayData, batch)
      })
      this.batches = utils.func.refreshJSON(this.batches)
    },
    searchGlobalMonthOk(type) {
      // Close the date picker after selecting month
      switch (type) {
        case 'liveDate':
          this.globalFilter.liveDatePicker = false
          break;
      }
      this.searchLiveDataFilter()
    },
    cancelGlobalMonth(type) {
      // Cancel and clear the global filter
      switch (type) {
        case 'liveDate':
          this.globalFilter.liveDatePicker = false
          this.globalFilter.searchliveDateMonth = ''
          break;
      }
      this.searchLiveDataFilter()
    },
    searchMonthOk(batch, type) {
      // this.$refs.dueDatePicker.save(batch.filter.searchMonth);
      switch (type) {
        case 'liveDate':
          batch.filter.liveDatePicker = false
          break;
        case 'dueDate':
          batch.filter.dueDatePicker = false
          break;
        case 'paymentDate':
          batch.filter.paymentDatePicker = false
          break;
      }
      this.searchFilter(batch);
    },
    cancelMonth(batch, type) {
      switch (type) {
        case 'liveDate':
          batch.filter.liveDatePicker = false
          batch.filter.searchliveDateMonth = ''
          break;
        case 'dueDate':
          batch.filter.dueDatePicker = false
          batch.filter.searchDueDateMonth = ''
          break;
        case 'paymentDate':
          batch.filter.paymentDatePicker = false
          batch.filter.searchPaymentDateMonth = ''
          break;
      }
      this.searchFilter(batch)
    },
    // checkBatch(date) {
    //   if (!date) return null;
    //   let day = moment(date).format('D')
    //   if (day <= 15) {
    //     return this.sectionIDs.BATCH_ONE
    //   }
    //   if (day > 15) {
    //     return this.sectionIDs.BATCH_TWO
    //   }
    //   return null
    // },
    clearselectedBatch(batchNo) {
      if (batchNo === this.sectionIDs.BATCH_ONE) {
        this.batches[0].data = [];
      } else {
        this.batches[1].data = [];
      }
    },
    // setBatchTableSections(batches, sections) {
    //   for (let i = 1; i <= 7; i++) {
    //     batches.push(this.getBatchTableData(i, sections))
    //   }
    // },
    // formatPosts(posts, sections) {
    //   posts = Object.assign([], posts).sort((a, b) => a.lineUpIndex - b.lineUpIndex);
    //   if (this.mainFilter.POC) {
    //     posts = posts.filter(p => {
    //       if (p.POC && find(p.POC, { id: this.currentUserID })) return true
    //       return false
    //     })
    //   }
    //   for (let element of posts) {
    //     if (element.POC) {
    //       element.POCDisplay = utils.func.refreshJSON(element.POC)
    //       element.POCDisplay = element.POCDisplay.map(p => {
    //         let user = this.Users.find(u => u.id === p.id)
    //         if (user) p.name = user.name
    //         return p
    //       })
    //       element.POCDisplay = element.POCDisplay.map(p => p.name).join(', ')
    //     }
    //     element.paymentDate = this.formatDate(element.paymentDate)
    //     element = this.setDefaultEditFields(element)
    //     let sectionRets = this.setBatchSectionsData(element, sections)
    //     element = sectionRets.element
    //     sections = sectionRets.sections
    //     // if (!element.archive) {
    //     //   element = this.setBatchSectionsData(element, sections)
    //     // }
    //     // if (!element.imported) {
    //     element.liveDate = this.formatDate(element.liveDate)
    //     element.overdue = this.checkOverDue(element.dueDate)
    //     element.early = this.checkEarly(element.dueDate)
    //     element.dueDate = this.formatDate(element.dueDate)
    //     // }
    //     if (element.partialAmount.length > 0 || element.importedAmount) {
    //       element.paidAmount = this.getPaidAmount(element)
    //       element.amount = this.getRemainAmount(element)
    //     }
    //   }
    //   return {
    //     posts,
    //     sections
    //   }
    // },
    // setBatchSectionsData(element, sections) {
    //   let status = element.payment_status
    //   // if paid, go to completed table
    //   if (status === this.paymentStatus.PAID) {
    //     element.batchNo = 'completed'
    //     sections.completed.push(element)
    //   } else if (status === this.paymentStatus.PARTIAL) {
    //     element.batchNo = 'partial'
    //     sections.partiallyPaid.push(element)
    //   } else if (status === this.paymentStatus.PROCESSING) {
    //     // if others, check imported and go to batches table
    //     if (element.imported) {
    //       element.batchNo = 'imported'
    //       sections.imported.push(element)
    //     } else {
    //       element.batchNo = element.liveDate ? this.checkBatch(element.liveDate) : this.sectionIDs.BATCH_ONE
    //       if (element.batchNo === this.sectionIDs.BATCH_ONE) {
    //         sections.batchOne.push(element)
    //       }
    //       if (element.batchNo === this.sectionIDs.BATCH_TWO) {
    //         sections.batchTwo.push(element)
    //       }
    //     }
    //   } else if (status === this.paymentStatus.APPROVAL_FINANCE) {
    //     element.batchNo = 'approvalFinance'
    //     sections.approvalFinance.push(element)
    //   } else if (status === this.paymentStatus.APPROVAL_LEAD) {
    //     element.batchNo = 'approvalLead'
    //     sections.approvalLead.push(element)
    //   }
    //   return {
    //     element,
    //     sections
    //   }
    // },
    restoreChanges() {
      this.oldBatches.map((batch, index) => {
        let currentBatch = this.batches[index]
        currentBatch.disableSaveEdit = batch.disableSaveEdit
        let selectedIds = batch.selectedPayments.map(selected => selected.id)
        currentBatch.selectedPayments = this.batches[index].displayData.filter(display => selectedIds.includes(display.id))
        currentBatch.filter = batch.filter
        this.batches[index] = currentBatch
      })
      this.batches = this.batches.map(batch => {
        batch = this.searchFilter(batch, true)
        return batch
      })
      this.batches = Object.assign([], this.batches)
      this.searchGlobal()
    },
    // reloadManually() {
    //   /**
    //    * --- set tmp batches as old at first
    //    * --- check matched influencer to update data and influencer personal info
    //    */
    //   this.oldBatches = Object.assign([], this.batches)
    //   this.getPaymentConsolidateReport()
    //   console.log(this.oldBatches)
    //   this.oldBatches.map((batch, index) => {
    //     let currentBatch = this.batches[index]
    //     currentBatch.disableSaveEdit = batch.disableSaveEdit
    //     let selectedIds = batch.selectedPayments.map(selected => selected.id)
    //     currentBatch.selectedPayments = batch.displayData.filter(display => selectedIds.includes(display.id))
    //     this.batches[index] = currentBatch
    //   })
    //   this.batches = Object.assign([], this.batches)
    //   console.log(this.batches)
    //   // for (let batch of this.oldBatches) {
    //   //   for (let data of batch.displayData) {
    //   //   }
    //   // }
    //   // for (let batch of this.batches) {
    //   //   for (let data of batch.displayData) {
    //   //     if (data.editReport === true) {
    //   //       let sameInfPostIds = this.originalPosts.filter(p => p.influencerID === data.influencerID || p.id === data.id).map(filtered => filtered.id)
    //   //       for (let postId of sameInfPostIds) {
    //   //         let sameInfPostIndex = this.originalPosts.findIndex(post => post.id === postId)
    //   //         if (sameInfPostIndex !== -1) {
    //   //           if (data.id === postId) {
    //   //             this.originalPosts[sameInfPostIndex] = data
    //   //           } else {
    //   //             this.originalPosts[sameInfPostIndex].swiftCode = data.swiftCode
    //   //             this.originalPosts[sameInfPostIndex].bankAccount = data.bankAccount
    //   //             this.originalPosts[sameInfPostIndex].username = data.username
    //   //           }
    //   //         }
    //   //       }
    //   //     }
    //   //   }
    //   // }
    //   // this.clearBatches()
    //   // this.setBatchSectionsData(this.originalPosts)
    //   // this.setBatchTableSections()
    //   // this.batches = utils.func.refreshJSON(this.batches)
    //   // this.oldBatches = []
    // },
    // getBatchTableData(id, sections) {
    //   let {name, batchNo, data, status, exportType} = this.getBatchSectionsData(id, sections)
    //   let selectedPayments = []
    //   // if (this.oldBatches) {
    //   //   let batchOne = this.oldBatches.find(old => old.batchNo === batchNo)
    //   //   selectedPayments = Object.assign([], batchOne.selectedPayments)
    //   // }
    //   let customHeaders = []
    //   if (batchNo === this.sectionIDs.BATCH_ONE || batchNo === this.sectionIDs.BATCH_TWO || batchNo === 'imported') {
    //     customHeaders = this.headers.filter(h => h.value !== 'paymentDate' &&
    //     h.value !== 'paymentSubmissionDate' &&
    //     h.value !== 'bankReference')
    //   } else customHeaders = Object.assign([], this.headers)
    //   return {
    //     id,
    //     name,
    //     batchNo,
    //     headers: customHeaders,
    //     displayData: data,
    //     data,
    //     disableSaveEdit: true,
    //     panel: [0],
    //     selectedPayments,
    //     filter: this.searchParams(),
    //     status,
    //     totalAmount: 0,
    //     exportType
    //   }
    // },
    // getBatchSectionsData(id, sections) {
    //   let batchInfo = {
    //     name: '',
    //     batchNo: '',
    //     data: [],
    //     status: '',
    //     exportType: ''
    //   }
    //   if (id === 1) {
    //     batchInfo.name = 'Imported'
    //     batchInfo.batchNo = 'imported'
    //     batchInfo.data = sections.imported
    //     batchInfo.status = this.paymentStatus.PROCESSING
    //     batchInfo.exportType = this.exportTypes.CO
    //   } else if (id === 2) {
    //     batchInfo.name = 'Batch 1'
    //     batchInfo.batchNo = this.sectionIDs.BATCH_ONE
    //     batchInfo.data = sections.batchOne
    //     batchInfo.status = this.paymentStatus.PROCESSING
    //     batchInfo.exportType = this.exportTypes.CO
    //   } else if (id === 3) {
    //     batchInfo.name = 'Batch 2'
    //     batchInfo.batchNo = this.sectionIDs.BATCH_TWO
    //     batchInfo.data = sections.batchTwo
    //     batchInfo.status = this.paymentStatus.PROCESSING
    //     batchInfo.exportType = this.exportTypes.CO
    //   } else if (id === 4) {
    //     batchInfo.name = 'Approval by Finance'
    //     batchInfo.batchNo = 'approvalFinance'
    //     batchInfo.data = sections.approvalFinance
    //     batchInfo.status = this.paymentStatus.APPROVAL_FINANCE
    //     batchInfo.exportType = this.exportTypes.CO
    //   } else if (id === 5) {
    //     batchInfo.name = 'Approval by Lead'
    //     batchInfo.batchNo = 'approvalLead'
    //     batchInfo.data = sections.approvalLead
    //     batchInfo.status = this.paymentStatus.APPROVAL_LEAD
    //     batchInfo.exportType = this.exportTypes.CO
    //   } else if (id === 6) {
    //     batchInfo.name = 'Pending Payment - WIP by Finance'
    //     batchInfo.batchNo = 'partial'
    //     batchInfo.data = sections.partiallyPaid
    //     batchInfo.status = this.paymentStatus.PARTIAL
    //     batchInfo.exportType = this.exportTypes.FINANCE
    //   } else if (id === 7) {
    //     batchInfo.name = 'Completed'
    //     batchInfo.batchNo = 'completed'
    //     batchInfo.data = sections.completed
    //     batchInfo.status = this.paymentStatus.PAID
    //     batchInfo.exportType = this.exportTypes.FINANCE
    //   }
    //   return batchInfo
    // },
    // getPaidAmount(item) {
    //   if (item.partialAmount === undefined && item.importedAmount === undefined) {
    //     return ''
    //   }
    //   let totalAmount = 0
    //   if (item.partialAmount.length > 0) {
    //     let partials = item.partialAmount
    //     let amounts = partials.map(p => p.amount)
    //     totalAmount += amounts.reduce((a, b) => parseInt(a) + parseInt(b))
    //   }
    //   if (item.importedAmount) {
    //     totalAmount += item.importedAmount
    //   }
    //   return totalAmount
    // },
    // getRemainAmount(item) {
    //   let paidAmounts = this.getPaidAmount(item)
    //   return parseInt(item.amount) - paidAmounts
    // },
    // checkOverDue(date) {
    //   if (!date) return false;
    //   let today = moment().format('YYYY-MM-DD')
    //   return date < today
    // },
    // checkEarly(date) {
    //   // if date within next 1 month
    //   if (!date) return false;
    //   let today = moment().format('YYYY-MM-DD')
    //   let oneMonthDate = moment().add(30, 'days').format('YYYY-MM-DD')
    //   return date > today && date < oneMonthDate
    // },
    // formatDate(date) {
    //   if (!date) return null;
    //   const [year, month, day] = date.split('-');
    //   let formattedDate = `${day}/${month}/${year}`
    //   if (formattedDate.includes('undefined')) {
    //     return date
    //   }
    //   return formattedDate;
    // },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    parseMonth(date) {
      /* eslint-disable */
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}`;
    },
    async getAllUsers() {
      // Only CC users are consumed by the filters and payment formatters.
      let response = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
      if (response) {
        this.Users = response.users
        this.Users = this.Users.map(u => {
          u.name = `${u.firstName}`
          return u
        })
        this.CCUsers = this.Users.filter(c => c.role === config.userRoles.AD_STRATEGIST)
        this.CCUsers.unshift({
          id: '',
          name: 'All CC'
        })
      }
    },
    async fetchCampaignList() {
      if (this.campaigns.length) return this.campaigns
      try {
        this.campaigns = await campaignAPIs.getAllCampaignsNoStatus() // In future, Campaign status could be change
      } catch (err) {
        console.log('Error:' + err);
      }
      return this.campaigns
    },
    changePaymentStatus(item) {
      if (!this.checkPaymentStatus(item)) {
        this.$swal({
          text: `Please Enter SwiftCode, Bank Account, Payee Name, Country, Bank Name and Email.`,
          type: 'warning'
        })
        // item.paymentStatus = utils.func.refreshJSON(item.oldPaymentStatus || item.payment_status) // set old payment status
        // item.paymentStatusEdit = false
        // this.batches = utils.func.refreshJSON(this.batches)
      }
      // item.oldPaymentStatus = item.oldPaymentStatus ? utils.func.refreshJSON(item.paymentStatus) :  utils.func.refreshJSON(item.payment_status)
    },
    checkPaymentStatus(item) {
      if ((!item.swiftCode || !item.bankAccount || !item.username || !item.country || !item.bankName || !item.email)
      && item.paymentStatus === this.paymentStatuses.PAID.value) {
        return false
      }
      return true
    },
    checkReportUpdate(item) {
      let isReportValid = true
      if (!item.editReport || item.editReport === false) {
        isReportValid = false
      }
      isReportValid = this.checkPaymentStatus(item) && item.editReport
      return isReportValid
    },
    openReportNotesDialog(item) {
      this.reportNotesData = item
      this.reportNotesDialog = true
      this.markNotesAsRead(item)
    },
    appendNote(internalNotes) {
      this.reportNotesData.internalNotes = this.reportNotesData.internalNotes || internalNotes
    },
    getNoteUnreadCount(item) {
      let unread = 0
      if (item.internalNotes !== undefined) {
        item.internalNotes.map(note => {
          note.read = note.read || []
          if (!note.read.includes(this.currentUserID)) {
            unread++
          }
        })
      }
      return unread
    },
    markNotesAsRead(item) {
      let unreadNoteIDs = []
      if (item.internalNotes !== undefined) {
        for (let note of item.internalNotes) {
          note.read = note.read || []
          if (!note.read.includes(this.currentUserID)) {
            unreadNoteIDs.push(this.currentUserID)
            note.read.push(this.currentUserID)
            this.updateReadNote(item.id, unreadNoteIDs)
          }
        }
      }
      item.internalNotes = utils.func.refreshJSON(item.internalNotes)
    },
    updateReadNote(id, unreadNoteIDs) {
      let formData = new FormData();
      formData.append('reportID', id);
      formData.append('unreads', unreadNoteIDs);
      campaignAPIs
        .saveReportNoteRead(formData)
        .then((response) => {
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeBankName(item) {
      item.swiftCode = ''
      let bank = ''
      if (item.bankName && item.bankName.bank) {
        bank = item.bankName.bank
      } else {
        bank = item.bankName
      }
      let matchBank = this.swiftCodes.find(b => b.bank === bank)
      if (matchBank) {
        item.swiftCode = matchBank.code
      } else {
        let matchBankAcc = bankAccounts.find(b => b.bank === bank)
        if (matchBankAcc) {
          item.swiftCode = matchBankAcc.code
        }
      }
    },
    changeCountry(item) {
      try {
        this.bankNames = []
        let country = this.countries.find(c => c.name === item)
        if (!country) {
          return;
        }
        this.disableBankSelect = true
        this.getBanks(country.code)
        this.disableBankSelect = false
      } catch (err) {
        console.log(err)
        this.bankNames = []
        this.disableBankSelect = false
      }
    },
    async getBanks(code) {
      try {
        let response = await influencerAPIs.getBanks(code)
        this.allBanks = response || []
        // Filter and populate bankNames from API response
        let matchBank = this.allBanks.find(bank => bank.country_code === code)
        if (matchBank && matchBank.list !== undefined) {
          this.bankNames = matchBank.list.filter(bank => bank.branch === null)
        }
      } catch (error) {
        console.log('Error fetching banks:', error);
        this.allBanks = []
        this.bankNames = []
      }
    },
    // checkDisabled(item) {
    //   if (item.payment_status === this.paymentStatus.APPROVAL_FINANCE) {
    //     if (!item.swiftCode || !item.bankAccount || !item.username) {
    //       return true
    //     }
    //   }
    //   return false
    // },
    clearBatches() {
      this.batches = []
      this.batchSections = utils.func.refreshJSON(this.defaultSections)
    },
    // clearArchives() {
    //   this.displayArchives = []
    //   this.archiveReportSections = utils.func.refreshJSON(this.defaultSections)
    // },
    filterPaymentStatusOptions(item) {
      let batchNo = item.batchNo
      let matchBatch = this.batches.find(batch => batch.batchNo === batchNo)
      if (matchBatch) {
        return this.allowedStatuses.filter(al => al.allowedStatusChange.includes(matchBatch.status))
      }
      return []
    },
    buttonShow(type) {
      if (this.currentUserRole === config.userRoles.ACCOUNT_MANAGER) {
        return false
      }
      return true;
    },
    openCreatePaymentConsolidateModal(item = null) {
      this.editInvoice = {}
      this.reportUpdate = false
      if (item) {
        this.editInvoice = Object.assign({}, item)
        this.reportUpdate = true
      }
      this.createPaymentConsolidateDialog = true
    },
    openInvoiceModal() {
      this.invoiceDialog = true
    },
    searchGlobal() {
      this.batches = this.batches.map(batch => {
        batch.filter.workingSearch = this.searchText
        return batch
      })
      this.invoiceSearch = this.searchText
    },
    changeSearch(batch, batchFilter, keyword) {
      batchFilter.workingSearch = keyword
    },
    openViewInvoiceModal() {
      this.invoiceViewDialog = true
    },
    // async openArchiveModal() {
    //   this.isLoading = true
    //   let payload = Object.assign({}, {
    //     filters: {
    //       archive: true
    //     }
    //   })
    //   await this.$store.dispatch('campaign/getPaymentConsolidateReport', payload)
    //   this.clearArchives()
    //   let formattedRets = this.formatPosts(this.archiveReports, this.archiveReportSections)
    //   this.archiveReports = formattedRets.posts
    //   this.archiveReportSections = formattedRets.sections
    //   this.setBatchTableSections(this.displayArchives, this.archiveReportSections)
    //   this.displayArchives = utils.func.refreshJSON(this.displayArchives)
    //   this.isLoading = false
    //   // this.archiveViewDialog = true
    // },
    deleteReport(id, item) {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to delete?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true;
          await paymentAPIs.deleteImportedPayment(id)
          if (item.reportID) {
            let payload = Object.assign({}, {
              id,
              params: { noreload: true }
            })
            await this.$store.dispatch('campaign/deleteReport', payload)
          }
          // if (!this.updatedReport) {
          //   this.$swal({
          //     text: 'Error Deleting Reports.',
          //     type: 'error'
          //   });
          //   return
          // }
          // Show success message
          this.$swal({
            text: 'Successfully deleted.',
            type: 'success'
          });
        }
        this.getPaymentConsolidateReport()
        
      });
    },
    deleteMultipleReport() {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to delete?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true;
          for (let batch of this.batches) {
            for (let payment of batch.selectedPayments) {
              // The `imported` flag follows a payout after it is pushed down,
              // so Finance-stage status must take precedence over that flag.
              // For rows still at PROCESSING, `imported` distinguishes the
              // ImportedPayment collection from PreProcessingPayment.
              if (payment.status === this.paymentStatuses.PARTIAL.value || payment.status === this.paymentStatuses.APPROVAL_FINANCE.value) {
                await paymentAPIs.deleteProcessingPayment(payment.id)
              } else if (payment.imported) {
                await paymentAPIs.deleteImportedPayment(payment.id)
                if (payment.reportID) {
                  let payload = Object.assign({}, {
                    id: payment.reportID,
                    params: { noreload: true }
                  })
                  await this.$store.dispatch('campaign/deleteReport', payload)
                }
              } else if (payment.status === this.paymentStatuses.PROCESSING.value) {
                await paymentAPIs.deletePreProcessingPayment(payment.id)
              }
            }
          }
          // if (!this.updatedReport) {
          //   this.$swal({
          //     text: 'Error Deleting Reports.',
          //     type: 'error'
          //   });
          //   return
          // }
          // Show success message
          this.$swal({
            text: 'Successfully deleted.',
            type: 'success'
          });
          this.getPaymentConsolidateReport()
        }
      });
    },
    displayGSTText(item) {
      return `$${(item.amount + (item.paidAmount || 0)) - item.GSTPercent} + $${item.GSTPercent} (GST)`
    },
    changeSwiftCode(item) {
      let matchBank = this.bankSwiftCodes.find(b => b.code === item.swiftCode)
      if (matchBank) {
        item.bankName = matchBank.bank
      }
    },
    setCountries() {
      // Retrieve countries manually
      this.countries = countries
    },
    setFilterCountries() {
      let countries = new Set()
      this.consolidateReports.map(c => {
        if (c.country) countries.add(c.country)
      })
      this.filterCountries = [...countries]
      this.filterCountries.unshift({name: 'All Country'})
    },
    resetFilter(batch) {
      batch.filter = this.searchParams()
      this.searchFilter(batch)
    },
    isDeleteAction(selectedPayments) {
      let isImported = selectedPayments.find(s => ((s.paymentStatus === this.paymentStatus.APPROVAL_FINANCE ||
      s.paymentStatus === this.paymentStatus.PARTIAL ||
      s.paymentStatus === this.paymentStatus.PROCESSING) && this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH) ||
      s.imported)
      return isImported ? true : false
    },
    fixTwoDec(amt) {
      return Number(amt).toFixed(2)
    },
    async getUploadedInvoiceLists() {
      await this.$store.dispatch('campaign/getUploadedInvoiceLists')
    },
    async refreshPayCons() {
      await this.getUploadedInvoiceLists()
      this.getPaymentConsolidateReport()
    }
    // searchParams() {
    //   return Object.assign({}, {
    //     search: '',
    //     workingSearch: '',
    //     searchliveDateMonth: '',
    //     searchDueDateMonth: '',
    //     selectedMonth: '',
    //     liveDatePicker: false,
    //     dueDatePicker: false,
    //     paymentStatus: this.paymentStatus.NEW,
    //     imported: false,
    //     country: 'All Country'
    //   })
    // }
  }
};
</script>
<style scoped>
  .table-small tbody td {
    padding: 5px!important;
  }
  .table-small tbody td .input-field {
    font-size:13px;
  }
  .table-small tbody td .custom-checkbox {
    padding: 0 16px;
  }
  .item-edit {
    min-width: 75px;
    min-height: 75px;
    padding-top: 30px;
  }
  .payment-consolidate-section .expansion-panel-header {
    min-height: 50px!important;
    padding: 10px 20px!important;
  }
  .payment-consolidate-section .expansion-panel-header h3 {
    font-size: 20px;
    font-weight: 600;
  }
  .payment-consolidate-section .action-section {
    padding: 0 20px!important;
  }
  .payment-consolidate-section .action-section > .action-group-section {
   padding-top: 25px;
  }
  .payment-consolidate-section .btn-payment-action {
    font-size: 11px;
    min-width: 130px!important;
    max-width: 130px!important;
  }
  .payment-xhs-logo {
    filter: invert(17%) sepia(96%) saturate(6784%) hue-rotate(356deg) brightness(103%) contrast(119%);
  }
</style>
<style>
  .payment-consolidate-table thead > tr:last-child > th {
    font-size: 12px!important;
    padding: 3px!important;
    padding-left: 12px!important;
    border: 1px solid #f5efef;
  }
  .payment-consolidate-table .v-data-table-header .v-simple-checkbox {
    padding-left: 4px!important;
  }
  .payment-consolidate-section .expansion-panel-content .v-expansion-panel-content__wrap {
    padding: 0px!important;
  }
  .payment-consolidate-section .imported-only-checkbox .v-label {
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// PaymentConsolidation.vue?24f85de0